module.exports = __webpack_public_path__ + "static/media/joined_dots.4b039a4c.svg";